import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { MatChip } from '@angular/material/chips';

@Component({
  imports: [MatChip, NgClass],
  selector: 'mat-pill',
  styleUrl: './mat-pill.component.scss',
  templateUrl: './mat-pill.component.html',
})
export class MatPillComponent {
  public text = input.required<string>();
  public class = input<string>();
  public disabled = input<boolean>();
}
